import component from 'element-plus/es/components/tree-select/src/tree-select-option.mjs'
import { createRouter, createWebHistory } from 'vue-router'

//路由规则

const routes = [
  {
    path: '/',
    component: () => import('../views/home.vue'),
  },
  {
    path: '/achievement',
    component: () => import('../views/achievement.vue'),
  },
  {
    path: '/achievement/:id', // 详情页路由，:id 是动态参数（存储成果ID）
    name: 'AchievementDetail',
    component: () => import('../views/achievementDetail.vue'),
    props: true
  },
  {
    path: '/techDemand',
    component: () => import('../views/techDemand.vue'),
  },
  {
    path: '/techDemand/:id', // 详情页路由，:id 是动态参数（存储成果ID）
    name: 'TechDemandDetail',
    component: () => import('../views/techDemandDetail.vue'),
    props: true // 开启props传参，可在详情页直接通过props接收id
  },
  {
    path: '/institution',
    component: () => import('../views/institution.vue'),
  },
  {
    path: '/manager/institution-manager',
    component: () => import('../views/manager/institutions.vue')
  },
  {
    path: '/institution/:id', // 详情页路由，:id 是动态参数（存储成果ID）
    name: 'InstitutionDetail',
    component: () => import('../views/institutionDetail.vue'),
    props: true // 开启props传参，可在详情页直接通过props接收id
  },
  {
    path: '/university/:id', // 详情页路由，:id 是动态参数（存储成果ID）
    name: 'UniversityDetail',
    component: () => import('../views/universityDetail.vue'),
    props: true // 开启props传参，可在详情页直接通过props接收id
  },
  {
    path: '/enterprise',
    component: () => import('../views/enterprise.vue'),
  },
  {
    path: '/enterprise/:id', // 详情页路由，:id 是动态参数（存储成果ID）
    name: 'EnterpriseDetail',
    component: () => import('../views/enterpriseDetail.vue'),
    props: true // 开启props传参，可在详情页直接通过props接收id
  },

  {
    path: '/experts',
    component: () => import('../views/experts.vue'),
  },
  {
    path: '/experts/:id', // 详情页路由，:id 是动态参数（存储成果ID）
    name: 'ExpertDetail',
    component: () => import('../views/expertDetail.vue'),
    props: true // 开启props传参，可在详情页直接通过props接收id
  },

  {
    path: '/instruments',
    component: () => import('../views/instruments.vue'),
  },
  {
    path: '/instruments/:id', // 详情页路由，:id 是动态参数（存储成果ID）
    name: 'InstrumentDetail',
    component: () => import('../views/instrumentDetail.vue'),
    props: true // 开启props传参，可在详情页直接通过props接收id
  },
  {
    path: '/investmentCompanys',
    component: () => import('../views/investmentCompanys.vue'),
  },
  {
    path: '/investmentCompanys/:id', // 详情页路由，:id 是动态参数（存储成果ID）
    name: 'InvestmentCompanyDetail',
    component: () => import('../views/investmentCompanyDetail.vue'),
    props: true // 开启props传参，可在详情页直接通过props接收id
  },
  {
    path: '/news',
    component: () => import('../views/news.vue'),
  },
  {
    path: '/news/:id', // 详情页路由，:id 是动态参数（存储成果ID）
    name: 'NewsDetail',
    component: () => import('../views/newsDetail.vue'),
    props: true // 开启props传参，可在详情页直接通过props接收id
  },
  {
    path: '/m/login',
    name: 'ManagerLogin',
    component: () => import('../views/manager/login.vue'),
  },
  {
    path: '/manager/home',
    name: 'ManagerHome',
    component: () => import('../views/manager/home.vue'),
  },
  {
    path: '/manager/scientific-achievements',
    name: 'ScientificAchievements',
    component: () => import('../views/manager/achievements.vue'),
  },
  {
    path: '/manager/instrument-sharing',
    name: 'InstrumentSharing',
    component: () => import('../views/manager/instrument.vue'),
  },
  {
    path: '/manager/technical-needs',
    name: 'Technical-needs',
    component: () => import('../views/manager/techDemands.vue'),
  },  
  {
    path: '/manager/expert-manager',
    name: 'ExpertManager',
    component: () => import('../views/manager/expertsManager.vue'),
  },
  {
    path: '/dataShow',
    name: 'DataShow',
    component: () => import('../views/echartsShow/EchartsHome.vue'),
  },

]
//创建路由器，在里面设置路由规则，还有历史信息的模式
const router = createRouter({
  history: createWebHistory(),
  routes
})

// 全局前置守卫：登录验证
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  
  // 访问管理后台路由（排除登录页）
  if (to.path.startsWith('/manager') && to.path !== '/m/login') {
    // 如果没有 token，重定向到登录页
    if (!token) {
      next('/m/login')
      return
    }
  }
  
  // 如果已登录，访问登录页时重定向到管理后台首页
  if (to.path === '/m/login' && token) {
    next('/manager/home')
    return
  }
  
  next()
})

//导出路由器
export default router
